import React from "react";

import Clearfix from "components/common/Clearfix";
import {
  PRIVACY_LINK,
  TERMS_LINK,
  VENDERS_LINK,
  FB_LINK,
  TWITTER_LINK
} from "constants/etomin";

import "assets/styles/layout/Footer.scss";

import fb from "assets/img/etomin-facebook.svg";
import twitter from "assets/img/etomin-twitter.svg";
import logo from "assets/img/logo-white.svg";
import venders from "assets/img/venders-logo.svg";

const Footer = () => {
  return (
    <div className={'footerWrapper'}>
      <div className={'footer'}>
        <div className={'footerSection'}>
          <div className={`${'left'}`}>
            <img className={'logo'} src={logo} alt="etomin" />
            <p className={'know'}>
              Solución de pagos de Grupo Venders
            </p>
            <ul className={'solutions'}>
              <li>
                <a href={VENDERS_LINK} target={"__blank"}>
                  <img src={venders} alt={"logo"} />
                </a>
              </li>
              {/* <li>
                <a href={IKNIU_LINK} target={"__blank"}>
                  <img src={ikniu} alt={"logo"} />
                </a>
              </li>
              <li>
                <a href={ANKOO_LINK} target={"__blank"}>
                  <img src={ankoo} alt={"logo"} />
                </a>
              </li>
              <li className={'pakke'}>
                <a href={PAKKE_LINK} target={"__blank"}>
                  <img src={pakke} alt={"logo"} />
                </a>
              </li> */}
            </ul>
          </div>
        </div>
        <div className={'footerSection'}>
          <div className={'contactInfo'}>
            <h3>Contacto</h3>
            <ul>
              <li>
                <strong>Correo:</strong> <a href="mailto:comercial@etomin.com">comercial@etomin.com</a>
              </li>
              <li>
                <strong>Teléfono:</strong> <a href="tel:+525515472785">+ 52 55 1547 2785</a>
              </li>
              <li>
                <strong>Dirección:</strong> Av. Constituyentes 908, Col. Lomas Altas,<br />
                Del. Miguel Hidalgo, Ciudad de México, CP 11950
              </li>
            </ul>
          </div>
        </div>
        <Clearfix />
      </div>

      <div className={'subfooterWrapper'}>
        <div className={'subfooter'}>
          <ul className={'left'}>
            <li>
              <a href={PRIVACY_LINK}>
                Aviso de privacidad
              </a>
            </li>
            <li>
              <a href={TERMS_LINK}>
                Términos y Condiciones
              </a>
            </li>
          </ul>
          <ul className={`${'right'} ${'smHide'}`}>
            <li>&copy; {new Date().getFullYear()} Venders. Todos los derechos reservados</li>
          </ul>
          <Clearfix />
        </div>
      </div>
    </div>
  );
};

export default Footer;
